export const theme = {
  colors: {
    bright: "#fff",
    dark: "#060513",
    accent: "#5e52f8",
    lightAccent: "#F0EEFF",
    text: {
      bright: "#fff",
      dark: "#060513",
      accent: "#5e52f8",
    },
  },
  typography: {
    fontFamily: "'Figtree', sans-serif",
    lineHeight: 1.2,
    headings: {
      h1: {
        size: { sm: "2rem", md: "2.5rem", lg: "3rem", xl: "47px" },
        weight: 700,
      },
      h2: {
        size: { sm: "1.75rem", md: "2rem", lg: "2.5rem", xl: "34px" },
        weight: 600,
      },
      h3: {
        size: { sm: "1.5rem", md: "1.75rem", lg: "2rem", xl: "22px" },
        weight: 500,
      },
      h4: {
        size: { sm: "1.25rem", md: "1.5rem", lg: "1.75rem", xl: "20px" },
        weight: 500,
      },
      h5: {
        size: { sm: "1.25rem", md: "1.5rem", lg: "1.75rem", xl: "22px" },
        weight: 500,
      },
    },
    text: {
      small: { sm: "12px", md: "14px", lg: "16px", xl: "14px" },
      basic: { sm: "14px", md: "16px", lg: "18px", xl: "16px" },
      big: { sm: "16px", md: "18px", lg: "20px", xl: "22px" },
    },
  },
  layout: {
    containerWidth: "1200px",
    breakpoints: {
      sm: "480px",
      md: "768px",
      lg: "1024px",
      xl: "1200px",
    },
    sectionPadding: {
      paddingSmall: {
        sm: "40px",
        md: "40px",
        lg: "50px",
        xl: "60px",
      },
      paddingBig: {
        sm: "50px",
        md: "60px",
        lg: "70px",
        xl: "140px",
      },
    },
    radius: {
      basic: "22px",
      img: "22px",
    },
  },
};
